import { inject, Injectable, signal } from '@angular/core';
import { CreateVideoComplianceDocDto } from '../../common/general-types/compliance-docs.dto';
import { environment } from '../../../environments/environment';
import { FirebaseService } from '../../common/firebase/firebase.service';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComplianceDocsService {

  private http = inject(HttpClient);
  private firebaseService = inject(FirebaseService);

  brandComplianceDocs = signal<any[] | undefined>(undefined);

  createComplianceDoc(complianceDoc: CreateVideoComplianceDocDto) {
    const create_compliance_doc_url = `${environment.shout_api.url}/video-compliance-docs`;
    return this.http.post(create_compliance_doc_url, complianceDoc, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getBrandComplianceDocs(businessAccountId: string, refresh: boolean = false) {
    if (this.brandComplianceDocs() && !refresh) {
      console.log('Returning cached compliance docs');
      return of(this.brandComplianceDocs() as any[]);
    }
    console.log('Fetching compliance docs from API');
    const get_brand_compliance_docs_url = `${environment.shout_api.url}/video-compliance-docs/business-account/${businessAccountId}`;
    return this.http.get<any[]>(get_brand_compliance_docs_url, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).pipe(
      tap((response) => {
        this.brandComplianceDocs.set(response);
      })
    );
  }

  getComplianceDocs(complianceDocIds: string[]) {
    const get_compliance_docs_url = `${environment.shout_api.url}/video-compliance-docs/get-compliance-docs`;
    const payload: { ids: string[] } = { ids: complianceDocIds };
    return this.http.post<any[]>(get_compliance_docs_url, payload, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }
}
